import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography } from "@mui/material";
import SummaryCard from "../../components/dashboard/SummaryCard";
import {
  fetchTotalTenants,
  fetchTotalRentalProperties,
  fetchBuildingCount,
} from "../../services/api/dashboard";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/slices/toastSlice";

const InventorySummary = () => {
  // -----------useState----------------------
  const dispatch = useDispatch();

  const [data, setData] = useState({
    totalTenant: 0,
    totalAvailableRentalProperty: 0,
    totalAvailableBuildings: 0,
  });

  // ------------useEffect------------------------
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const totalTenant = await fetchTotalTenants();
        const totalAvailableRentalProperty = await fetchTotalRentalProperties();
        const totalAvailableBuildings = await fetchBuildingCount();

        setData({
          totalTenant: totalTenant.data,
          totalAvailableRentalProperty: totalAvailableRentalProperty.data,
          totalAvailableBuildings: totalAvailableBuildings.data,
        });
      } catch (error) {
        dispatch(showToast({ message: error.message, severity: "error" }));
      }
    };
    fetchCount();
  }, []);

  // Metrics configuration (dynamic JSON data)
  const metrics = [
    {
      count: data.totalTenant,
      title: "Tenants",
      description: "Number of tenants in the inventory",
      backgroundColor: "#4682B4",
    },
    {
      count: data.totalAvailableRentalProperty,
      title: "Rental Properties",
      description: "Number of rental propeties in the inventory",
      backgroundColor: "#B7B1A8",
    },
    {
      count: data.totalAvailableBuildings,
      title: "Buildings",
      description: "Number of buildings in the inventory",
      backgroundColor: "#D4A5A5",
    },
  ];

  return (
    <>
      <Paper sx={{ width: "100%", mt: 4, mb: 2, p: 3, borderRadius: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Inventory Snapshot
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: "#999" }}>
          Stay informed about your product counts and categories to enhance
          inventory management.
        </Typography>
        <Grid container spacing={3} sx={{ mb: 2 }}>
          {/* Dynamically render SummaryCards */}
          {metrics.map((metric, index) => (
            <SummaryCard
              key={index}
              count={metric.count}
              title={metric.title}
              description={metric.description}
              backgroundColor={metric.backgroundColor}
            />
          ))}
        </Grid>
      </Paper>
    </>
  );
};

export default InventorySummary;
